export const Footer = () => {
  return <div className="footer">&copy; Caitlyn Homet 2023</div>;
}